/* eslint-disable import/default */
import './index.css'; // CSS injected via JS by vite-plugin-css-injected-by-js (non-blocking)
// import './instrument'; // Sentry disabled to reduce bundle size

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
